import getUpcomingDestinations from "./getUpcomingDestinations";

export default (destinations=[],state)=>{
    return getUpcomingDestinations(destinations).filter( (d) => d.state === state);
}
